import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach Authorization + X-Company-Id on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kosh_token");
  const companyId = localStorage.getItem("kosh_company_id");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (companyId) config.headers["X-Company-Id"] = companyId;
  return config;
});

// Global 401 handler: clear token + bounce to /login
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("kosh_token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const formatINR = (n) => {
  const num = Number(n || 0);
  return new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(num);
};

export const formatINRDecimal = (n) => {
  const num = Number(n || 0);
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

export const errDetail = (detail) => {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail.msg) return detail.msg;
  return String(detail);
};
